// eslint-disable-next-line import/prefer-default-export
export const getIsSavingDados = (state) => state.servico.isSaving
